module.exports = __webpack_public_path__ + "img/Platine_0002_3.a7477306.png";